import React, { Component, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form-html5-validation';
import { FieldArray } from "react-final-form-arrays";
import { OnChange } from 'react-final-form-listeners';
import * as actions from '../../actions';
import {
    isRequiredText,
    isRequiredQuestionSelection,
    isRequiredSelectionCheckbox,
    conditionallyRequiredText,
    isRequiredSignature,
    isRequiredPhoneNumber,
    numberValidator,
    isRequired
} from '../helpers/Validation';
import { textField } from '../helpers/Form';
import prescriber from '../terms/prescriber';
import SignatureCanvas from 'react-signature-canvas';
import arrowUp from '../../assets/images/arrow-up.png';
import arrowDown from '../../assets/images/arrow-down.png';
import SignatureDate from '../hooks/SignatureDate';

class Step4 extends Component {

    constructor(props) {
        super(props)
        this.state = {
            prescriberAgentSignatureDate: null,
            acadiaConnectServicesOther: "hidden",
            prescriberAgentSignature: null,
        }
    }

    clearSigCanvas = (refName) => {
        this[(refName + "Ref")].clear();
    }

    storeSigData = (refName) => {
        this.setState({
            ...this.state,
            [refName]: this[(refName + "Ref")].getTrimmedCanvas().toDataURL()
        })
        this.props.questionAnswer(refName, this[(refName + "Ref")].toDataURL());
    }

    toggleTextBox = (name) => {
        this.setState({
            ...this.state,
            [name]: !this.state[name]
        });
        this.prescriberTextBox.current.scrollIntoView({ behavior: "smooth" });
    }

    CheckboxGroup = ({ meta, fields, options }) => {
        const { experiencedOtherText } = this.props.questionOptions;
        const toggle = (event, option) => {
            console.log("event.target.checked", event.target.checked);
            if (event.target.checked) {
                console.log("option", option);
                fields.push(option);
                if(option === "Other") {
                    this.props.questionAnswer("experiencedOtherText", true);
                }
            }
            else {
                fields.remove(option);
                if(option === "Other") {
                    this.props.questionAnswer("experiencedOtherText", false);
                }
            }
        };
        const addText = (event, option) => {
            // Discard previous value and add a new one
            fields.remove(event.target.name);
            fields.push({[event.target.name]: event.target.value});
        };
        return (
            <Fragment>
                <label className={meta.touched && meta.error ? "fancy-label error" : "fancy-label" } style={{marginBottom: '24px'}} htmlFor="servicesNeeded inline-checkboxes">Please select the Acadia Connect&trade; services needed (check all that apply):*</label>
                {options.map(option => {
                    return (
                        <div key={option} className="row form-group form-group-checkbox">
                            <div className="container" style={{marginLeft: '0'}}>
                                <label
                                    className="acadia-checkbox inline-checkboxes custom-checkbox-label"
                                    style={{
                                        paddingLeft: '0px',
                                    }}
                                    >
                                        <input name="servicesNeeded" type="checkbox" onClick={event => toggle(event, option)} />
                                        <span class="checkmark"></span>
                                        <span className="checkbox-content">{option}</span>
                                </label>
                            </div>
                        </div>
                    )
                })}
                {meta.error && meta.touched && meta.error }
                {experiencedOtherText && (
                    <div className="relative form-group">
                        <textarea name="experiencedOtherText" onBlur={event => addText(event)} className="with-checkbox" />
                    </div>
                )}
            </Fragment>
        );
    }

    prescriberPhoneTwo = createRef();
    prescriberPhoneThree = createRef();
    prescriberTextBox = createRef();

    render() {
        const {
            formattedPrescriberAgentSignatureDate,
            prescriberTextBox
        } = this.state;
        const { currentStep } = this.props;
        const {
            confirmDiagnosis,
            confirmDose,
            prescriberPhoneOne,
            prescriberPhoneTwo,
            prescriberPhoneThree,
            prescriberAgentSignatureDate,
            prescriberAgentSignature
        } = this.props.questionOptions;

        const servicesNeededOptions = [
            "Perform a benefits investigation on behalf of your resident",
            "Support you in the prior authorization/appeals process, if required by your resident's insurance company",
            "Provide information about financial assistance program, if your resident is eligible"
        ];

        return (
            <Fragment>

                <div class="row">
                    <div class="col-lg-12">
                        <h3 className="euclid">SERVICE REQUEST FORM</h3>
                        <p>You can also download a <a href="/nuplazid/pdf/treatment-form-nuplazid.pdf" target="_blank">PDF version of the treatment form</a>&nbsp;to fill out and email to <a class="nobr" href="mailto:acadiaconnect@acadia-pharm.com " >acadiaconnect@acadia-pharm.com</a>.</p>
                    </div>
                </div>
                <div class="row spacer-medium">&nbsp;</div>
                <div className="row mobile-step-header">
                    <div className="col-sm-2 col-2">
                        <span className="header-number">{currentStep}</span>
                    </div>
                    <div className="col-sm-10 col-10 pl-0">
                        <h3 className="euclid">SERVICES NEEDED/DIAGNOSIS INFORMATION</h3>
                        <div className="d-inline-block"><i>All questions are required unless marked optional.</i></div>
                        <div className="text-right d-inline-block float-right pr-2">*required</div>
                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>


                <div className="row spacer-medium">&nbsp;</div>
                <div className="form-group ltc-enrollment-step4 iphone11-checkboxes-left-15px">

                    <FieldArray
                        name="servicesNeeded"
                        component={this.CheckboxGroup}
                        options={servicesNeededOptions}
                        validate={isRequiredSelectionCheckbox}
                    />
                </div>
                <div class="row spacer-medium">&nbsp;</div>
                <div className="row">
                    <div className="col-sm">
                        <div className="form-group">
                            <Field
                                name="confirmDiagnosis"
                                component="input"
                                defaultValue={confirmDiagnosis}
                                validate={isRequiredQuestionSelection}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label className={meta.touched && meta.error ? "fancy-label error" : "fancy-label" } htmlFor="confirmDiagnosis">Please confirm diagnosis*</label>
                                    </Fragment>
                                )}
                            </Field>
                            <div class="row spacer-small mobile">&nbsp;</div>
                            <div class="row">
                                <div class="col">
                                    <div className="radio-field">
                                        <Field name="confirmDiagnosis">
                                            {({ input, meta }) => {
                                                return(
                                                    <Fragment>
                                                        <input
                                                            id="confirmDiagnosisPD"
                                                            name={input.name}
                                                            type="radio"
                                                            style={{flexShrink: '0'}}
                                                            onClick={(e) => this.props.questionAnswer("confirmDiagnosis", "Hallucinations and delusions associated with PD psychosis")}

                                                        />
                                                    </Fragment>);
                                            }}
                                        </Field>
                                        <div style={{display: 'inline-grid'}}>
                                            <label htmlFor="confirmDiagnosisPD">Hallucinations and delusions associated with Parkinson's disease psychosis</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                <div className="radio-field">
                                        <Field name="confirmDiagnosis">
                                            {({ input, meta }) => {
                                                return(
                                                    <Fragment>
                                                        <input
                                                            id="confirmDiagnosisOther"
                                                            name={input.name}
                                                            type="radio"
                                                            style={{flexShrink: '0'}}
                                                            onClick={(e) => this.props.questionAnswer("confirmDiagnosis", "Other diagnosis")}
                                                        />
                                                    </Fragment>);
                                            }}
                                        </Field>
                                        <div style={{display: 'inline-grid'}}>
                                            <label htmlFor="confirmDiagnosisOther">Other diagnosis</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Field
                                name="confirmDiagnosis"
                                component="input"
                                defaultValue={confirmDiagnosis}
                                validate={isRequiredQuestionSelection}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                </div>

                {confirmDiagnosis === "Other diagnosis" && (
                    <div className="row">
                        <div className="col-sm">
                            <Field
                                name="diagnosisDescription"
                                label="Description:*"
                                component={textField}
                                validate={isRequiredText}
                            />
                        </div>
                    </div>
                )}


                <div className="row">
                    <div className="form-group">
                        <div className="col-sm">
                            <Field
                                name="confirmDose"
                                component="input"
                                defaultValue={confirmDose}
                                validate={isRequiredQuestionSelection}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label className={meta.touched && meta.error ? "blue-font-20 error" : "blue-font-20" } htmlFor="confirmDose">Please confirm dose*</label>
                                    </Fragment>
                                )}
                            </Field>
                            <div class="row">
                                <div class="col">
                                    <div className="radio-field">
                                        <Field name="confirmDose">
                                            {({ input, meta }) => {
                                                return(
                                                    <Fragment>
                                                        <input
                                                            id="confirmDose34mg"
                                                            name={input.name}
                                                            type="radio"
                                                            style={{flexShrink: '0'}}
                                                            onClick={(e) => this.props.questionAnswer("confirmDose", "34 mg capsule")}
                                                        />
                                                    </Fragment>);
                                            }}
                                        </Field>
                                        <div style={{display: 'inline-grid'}}>
                                            <label htmlFor="confirmDose34mg">34 mg capsule</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div className="radio-field">
                                        <Field name="confirmDose">
                                            {({ input, meta }) => {
                                                return(
                                                    <Fragment>
                                                        <input
                                                            id="confirmDoseOther"
                                                            name={input.name}
                                                            type="radio"
                                                            style={{flexShrink: '0'}}
                                                            onClick={(e) => this.props.questionAnswer("confirmDose", "Other")}
                                                        />
                                                    </Fragment>);
                                            }}
                                        </Field>
                                        <div style={{display: 'inline-grid'}}>
                                            <label htmlFor="confirmDoseOther">Other</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Field
                                name="confirmDose"
                                component="input"
                                defaultValue={confirmDose}
                                validate={isRequiredQuestionSelection}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                </div>

                {confirmDose === "Other" && (
                    <div className="row">
                        <div className="col-sm">
                            <Field
                                name="doseDescription"
                                label="Description*:"
                                component={textField}
                                validate={isRequiredText}
                            />
                        </div>
                    </div>
                )}

                <h5 className="medium-font font-20 blue-font">PRESCRIBER AUTHORIZATION</h5>
                <div className="row spacer-small" />
                <Field
                    name="prescriberAgentName"
                    label="Prescriber or authorized agent name:*"
                    placeholder="Prescriber or authorized agent name"
                    component={textField}
                    validate={isRequiredText}
                />
                <div className="row">
                    <div className="col-sm-6">
                        <Field
                            name="prescriberNpiNumber"
                            label="Prescriber NPI number:*"
                            placeholder="Prescriber NPI number"
                            component={textField}
                            validate={isRequiredText}
                            maxLength={10}
                            inputMode="numeric"
                        />
                    </div>
                    <div className="col-sm-6">
                        <Field
                            name="prescriberPhoneNumber"
                            component="input"
                            defaultValue={prescriberPhoneOne + prescriberPhoneTwo + prescriberPhoneThree}
                            validate={isRequiredPhoneNumber}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <label className={meta.error && meta.touched ? "fancy-label error" : "fancy-label"}>Prescriber phone number*</label>
                                </Fragment>
                            )}
                        </Field>
                        <div className="phone-group phone-group-validate">
                            <Field name="prescriberPhoneOne" component="input" validate={isRequired}>
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            className={meta.error && meta.touched ? "form-control inline-phone phone-area-code error" : "form-control inline-phone phone-area-code"}
                                            type="text"
                                            maxLength="3"
                                            placeholder="123"
                                            inputMode="numeric"
                                        />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                            <OnChange name="prescriberPhoneOne">
                                {(value, previous) => {
                                    if(numberValidator(value)) {
                                        this.props.questionAnswer("prescriberPhoneOne", value);
                                        if(value.length === 3) {
                                            this.prescriberPhoneTwo.current.focus();
                                        }
                                    }
                                }}
                            </OnChange>
                            <Field name="prescriberPhoneTwo" component="input"  validate={isRequired}>
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            className={meta.error && meta.touched ? "form-control inline-phone phone-prefix error" : "form-control inline-phone phone-prefix"}
                                            type="text"
                                            maxLength="3"
                                            placeholder="456"
                                            ref={this.prescriberPhoneTwo}
                                            inputMode="numeric"
                                        />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                            <OnChange name="prescriberPhoneTwo">
                                {(value, previous) => {
                                    if(numberValidator(value)) {
                                        this.props.questionAnswer("prescriberPhoneTwo", value);
                                        if(value.length === 3) {
                                            this.prescriberPhoneThree.current.focus();
                                        }
                                    }
                                }}
                            </OnChange>
                            <Field name="prescriberPhoneThree" component="input" validate={isRequired}>
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            className={meta.error && meta.touched ? "form-control inline-phone phone-line-number error" : "form-control inline-phone phone-line-number"}
                                            type="text"
                                            maxLength="4"
                                            placeholder="7890"
                                            ref={this.prescriberPhoneThree}
                                            inputMode="numeric"
                                        />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                            <OnChange name="prescriberPhoneThree">
                                {(value, previous) => {
                                    if(numberValidator(value)) {
                                        this.props.questionAnswer("prescriberPhoneThree", value);
                                    }
                                }}
                            </OnChange>
                        </div>
                            <Field
                                name="prescriberPhoneNumber"
                                component="input"
                                defaultValue={prescriberPhoneOne + prescriberPhoneTwo + prescriberPhoneThree}
                                validate={isRequiredPhoneNumber}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                    </div>
                </div>
                <div className="row spacer-small" style={{height: '30px'}}>&nbsp;</div>
                <div className="hipaa" ref={this.prescriberTextBox}>
                    <div className={"scroll-terms " + (prescriberTextBox ? "expanded" : "condensed")}>
                        {prescriber}
                    </div>
                    <button className="btn no-outline" onClick={() => this.toggleTextBox("prescriberTextBox")} type="button">
                        SEE {prescriberTextBox ? <Fragment>LESS<img className="arrow" src={arrowUp} alt="arrrow"/></Fragment> : <Fragment>MORE<img className="arrow" src={arrowDown} alt="arrrow" /></Fragment>}
                    </button>
                    <div className="row spacer-small" />
                    <div className="form-group">
                        <Field
                                name="prescriberAgentSignature"
                                defaultValue={prescriberAgentSignature}
                                component="input"
                                validate={isRequiredSignature}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <label className={meta.error && meta.touched ? "fancy-label error" :"fancy-label"} htmlFor="prescriberAgentSignature" style={{paddingBottom: '9px'}}>Prescriber or authorized agent (ie, nurse) signature*</label>
                                </Fragment>
                            )}
                        </Field>
                        <div className="text-center relative">
                            <SignatureCanvas
                             penColor='black'
                             canvasProps={{height: 200, className: 'sig-canvas'}}
                             onEnd={() => this.storeSigData("prescriberAgentSignature")}
                             ref={(ref) => { this.prescriberAgentSignatureRef = ref }}
                             clearOnResize={false}
                             />
                            <button type="button" className="canvas-clear" onClick={() => this.clearSigCanvas("prescriberAgentSignature")}>CLEAR</button>
                            <Field
                                name="prescriberAgentSignature"
                                defaultValue={prescriberAgentSignature}
                                component="input"
                                validate={isRequiredSignature}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                    <SignatureDate forDate="prescriberAgentSignature"/>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const { currentStep, questionOptions } = state;
    return { currentStep: currentStep, questionOptions: questionOptions };
}

  export default connect(mapStateToProps, actions)(Step4);
